import React from 'react'
import { useLocation } from 'react-router-dom'
import MainLayout from '../../components/common/MainLayout/MainLayout.component'
import AuthLayoutContainer from '../../container/CRM/AuthLayout.container'
import { IS_REGISTRATION_OPEN, REGISTER_SECRET_KEY, REGISTER_SECRET_KEY_PARAM } from '../../const/auth.const'
import { APPLICATION_DEADLINE_TEXT, FESTIVAL_YEAR } from '../../const/season.const'

import './Auth.style.scss'

const block = 'auth-page'

const AuthPage = (): JSX.Element => {
  const location = useLocation()
  const registerSecretKey = new URLSearchParams(location.search).get(REGISTER_SECRET_KEY_PARAM)
  const hasRegister = IS_REGISTRATION_OPEN || registerSecretKey === REGISTER_SECRET_KEY

  return (
    <div className={block}>
      <MainLayout>
        <div className={`${block}__content`}>
          <div className="content-container">
            <div className="page-title">
              {hasRegister
                ? <>
                  Введите данные для регистрации <br />или входа в личный кабинет
                  <p>Хотите стать участником фестиваля New Open {FESTIVAL_YEAR}?</p>
                </>
                : 'Введите данные для входа в личный кабинет'}
            </div>

            {hasRegister ? (
              APPLICATION_DEADLINE_TEXT && (
                <div className={`${block}__subtitle`}>
                  Успейте подать заявку {APPLICATION_DEADLINE_TEXT}
                </div>
              )
            ) : (
              <div className={`${block}__subtitle`}>
                Приём заявок на участие в фестивале New Open {FESTIVAL_YEAR} завершён
              </div>
            )}
          </div>

          <AuthLayoutContainer hasRegister={hasRegister} />
        </div>
      </MainLayout>
    </div>
  )
}

export default AuthPage
